import { performRequest, performRequestSecond, performRequestThird } from 'common/apiHandler';
import { default as apiEndPoints } from 'common/apiEndPoints';
import { FILEUPLOAD_S3_LEVEL, IMGUPLOAD_S3, SetS3Config } from 'config/amplify_config';
import { Storage } from 'aws-amplify';
import Cookies from 'universal-cookie';
import { AppConfig } from 'config/api_config';
const cookie = new Cookies();

const getTenantDetails = () => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replaceAll('#', '%23') : '';
  return [tenantId, tenantSk];
};
export const createCustomField = (data) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  //as an object {}
  return performRequest(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.createCustomField}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};

export const getCustomFields = (module = '', pageLimit = 10, pagination_token = '', pagination_direction = '', status = 'ACTIVE') => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  return performRequest(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.getCustomFieldList}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&limit=${pageLimit}&module_name=${module}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}&status=${status}`
  );
};

export const deleteCustomField = (pk, sk) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  let skNew = sk.replace('#', '%23');
  let skModified = skNew.replace('#', '%23');

  let pkNew = pk.replace('#', '%23');
  return performRequest(
    apiEndPoints.methodType.DELETE,
    `${apiEndPoints.deleteCustomField}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&pk=${pkNew}&sk=${skModified}`
  );
};

// export /update-position
export const updateCustomFieldOrder = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestThird(
    apiEndPoints.methodType.PUT,
    `${apiEndPoints.updateCustomFieldOrder}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};

export const editCustomField = (data) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  return performRequest(apiEndPoints.methodType.PUT, `${apiEndPoints.updateCustomField}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`, data);
};

export const createCaseMatter = (data) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  return performRequest(apiEndPoints.methodType.POST, `${apiEndPoints.createCaseMatter}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`, data);
};
export const updateCaseMatter = (data) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  return performRequest(apiEndPoints.methodType.PUT, `${apiEndPoints.updateCaseMatter}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`, data);
};
export const deleteCaseMatter = (pk, sk) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  let skNew = sk.replace('#', '%23');
  let skModified = skNew.replace('#', '%23');
  let pkNew = pk.replace('#', '%23');
  return performRequest(
    apiEndPoints.methodType.DELETE,
    `${apiEndPoints.deleteCaseMatter}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&pk=${pkNew}&sk=${skModified}`
  );
};
export const getCaseMatterList = () => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  return performRequest(apiEndPoints.methodType.GET, `${apiEndPoints.getCaseMatter}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`);
};

export const createPracticeArea = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.createPracticeArea}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};
export const updatePracticeArea = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(
    apiEndPoints.methodType.PUT,
    `${apiEndPoints.updatePracticeArea}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};
export const deletePracticeArea = (pk, sk) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let skNew = sk.replace('#', '%23');
  let skModified = skNew.replace('#', '%23');

  let pkNew = pk.replace('#', '%23');
  return performRequest(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.deletePracticeArea}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&pk=${pkNew}&sk=${skModified}`
  );
};

export const createCaseStage = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(apiEndPoints.methodType.POST, `${apiEndPoints.createCaseStage}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`, data);
};
export const updateCaseStage = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(apiEndPoints.methodType.PUT, `${apiEndPoints.updateCaseStage}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`, data);
};
export const deleteCaseStage = (pk, sk) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let skNew = sk.replace('#', '%23');
  let skModified = skNew.replace('#', '%23');
  let pkNew = pk.replace('#', '%23');
  return performRequest(
    apiEndPoints.methodType.DELETE,
    `${apiEndPoints.deleteCaseStage}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&pk=${pkNew}&sk=${skModified}`
  );
};
export const updateCaseStagePosition = (data, excludeFromLoading = false) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.updateCaseStagePosition}?tenant_id=${tenantId}&tenant_sk=${tenantSk}
    `,
    data,
    '',
    true,
    excludeFromLoading
  );
};
export const listLeadStages = (
  pageLimit,
  pagination_token,
  pagination_direction,
  lead_stage_status = '',
  data,
  sort_order = 'alphabet_ascending',
  inputValue = ''
) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(
    apiEndPoints.methodType.POST,
    `${
      apiEndPoints.listLeadStages
    }?tenant_id=${tenantId}&tenant_sk=${tenantSk}&limit=${pageLimit}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}&lead_stage_status=${lead_stage_status}&sort_order=${sort_order}${
      inputValue ? `&keyword=${inputValue}` : ''
    }`,
    data
  );
};

export const createLeadStages = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(apiEndPoints.methodType.POST, `${apiEndPoints.createLeadStage}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`, data);
};

export const updateLeadStage = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(apiEndPoints.methodType.PUT, `${apiEndPoints.updateLeadStage}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`, data);
};

export const deleteLeadStage = (pk, sk, lead_stage_status = '', excludeFromLoading = false) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let skNew = sk.replace('#', '%23');
  let skModified = skNew.replace('#', '%23');

  let pkNew = pk.replace('#', '%23');
  return performRequest(
    apiEndPoints.methodType.DELETE,
    `${apiEndPoints.deleteLeadStage}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&pk=${pkNew}&sk=${skModified}&lead_stage_status=${lead_stage_status}`,
    null,
    '',
    true,
    excludeFromLoading
  );
};

// Lawft ID APIs
export const createLawftId = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestSecond(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.createLawftId}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};

export const updateLawftId = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestSecond(
    apiEndPoints.methodType.PUT,
    `${apiEndPoints.updateLawftId}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};

export const deleteLawftId = (pk, sk, lawft_id_status = '') => {
  const [tenantId, tenantSk] = getTenantDetails();
  let skNew = sk.replace('#', '%23');
  let skModified = skNew.replace('#', '%23');

  let pkNew = pk.replace('#', '%23');
  return performRequestSecond(
    apiEndPoints.methodType.DELETE,
    `${apiEndPoints.deleteLawftId}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&pk=${pkNew}&sk=${skModified}&lawft_id_status=${lawft_id_status}`
  );
};

export const listLawftIds = (
  pageLimit = 10,
  pagination_token = '',
  pagination_direction = '',
  status = 'ACTIVE',
  data = {},
  sort_order = 'alphabet_ascending',
  practice_area = ''
) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestSecond(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.listLawftIds}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&limit=${pageLimit}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}&lawft_id_status=${status}&sort_order=${sort_order}&practice_area_id=${practice_area}`,
    data
  );
};

export const getOfficeLocations = () => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(apiEndPoints.methodType.GET, `${apiEndPoints.getOfficeLocations}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`);
};

export const getOfficeLocationsV2 = ({
  keyword = '',
  page = 1,
  limit = 10,
  sort_by = 'time',
  sort_order = 'desc',
  is_dropdown = false,
  include_contacts = false,
}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  const params = new URLSearchParams({
    tenant_id: tenantId,
    tenant_sk: tenantSk,
    page: String(page),
    limit: String(limit),
    sort_by,
    sort_order,
    is_dropdown: String(is_dropdown),
    include_contacts: String(include_contacts),
  });

  if (keyword) {
    params.append('keyword', keyword);
  }

  return performRequestSecond(apiEndPoints.methodType.GET, `${apiEndPoints.getOfficeLocationsV2}?${params.toString()}`);
};

export const createOfficeLocation = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.createOfficeLocation}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};

export const createCaseCourt = (data) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  return performRequest(apiEndPoints.methodType.POST, `${apiEndPoints.createCaseCourt}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`, data);
};

export const updateOfficeLocation = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(
    apiEndPoints.methodType.PUT,
    `${apiEndPoints.updateOfficeLocation}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};
export const deleteOfficeLocation = (pk, sk) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let skNew = sk.replace('#', '%23');
  let skModified = skNew.replace('#', '%23');

  let pkNew = pk.replace('#', '%23');
  return performRequest(
    apiEndPoints.methodType.DELETE,
    `${apiEndPoints.deleteOfficeLocation}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&pk=${pkNew}&sk=${skModified}`
  );
};

export const createContactGroups = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.createContactGroup}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};

export const createUserGroup = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(apiEndPoints.methodType.POST, `${apiEndPoints.createUserGroup}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`, data);
};

export const listUserGroups = () => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(apiEndPoints.methodType.GET, `${apiEndPoints.listUserGroups}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`);
};

export const listSettingsUserGroups = (
  pageLimit,
  pagination_token = '',
  pagination_direction = '',
  status = 'ACTIVE',
  sort_order = 'alphabet_ascending'
) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.listUserGroups}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&limit=${pageLimit}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}&status=${status}&sort_order=${sort_order}`
  );
};

export const deleteUserGroup = (status, data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.deleteUserGroup}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&status=${status}`,
    data
  );
};

export const updateUserGroup = (user_group_sk, edit_name, data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(
    apiEndPoints.methodType.PUT,
    `${apiEndPoints.updateUserGroups}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&user_group_sk=${user_group_sk}&edit_name=${edit_name}`,
    data
  );
};

export const createUserRole = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(apiEndPoints.methodType.POST, `${apiEndPoints.createUserRole}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`, data);
};

export const listUserRoles = (pageLimit, pagination_token = '', pagination_direction = 'forward') => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.listUserRoles}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&limit=${pageLimit}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}`
  );
};

export const listSettingsUserRoles = (pageLimit, pagination_token = '', pagination_direction = '') => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.listUserRoles}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&limit=${pageLimit}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}`
  );
};

export const getRoleDetails = (user_role_sk) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.userRoleDetails}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&user_role_sk=${user_role_sk}`
  );
};

export const updateRoleDetails = (user_role_sk, data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(
    apiEndPoints.methodType.PUT,
    `${apiEndPoints.updateRoleDetails}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&user_role_sk=${user_role_sk}`,
    data
  );
};

export const deleteUserRole = (user_role_sk) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequest(
    apiEndPoints.methodType.DELETE,
    `${apiEndPoints.deleteUserRole}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&user_role_sk=${user_role_sk}`
  );
};

export const deactivateFirmAccount = (status) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestSecond(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.deactivateFirmAccount}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&status=${status}`
  );
};

export const updateFirmName = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestThird(
    apiEndPoints.methodType.PUT,
    `${apiEndPoints.updateFirmName}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};

export const createSetting = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestSecond(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.createSettings}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};
export const updateSetting = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestSecond(
    apiEndPoints.methodType.PUT,
    `${apiEndPoints.updateSettings}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};

export const getSetting = () => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestSecond(apiEndPoints.methodType.GET, `${apiEndPoints.getSettings}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`);
};

// Automation Settings
export const getAutomationSettings = () => {
  const [tenantId, tenantSk] = getTenantDetails();
  const url = `${apiEndPoints.getAutomationSettings}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestSecond(apiEndPoints.methodType.GET, url);
};

export const updateAutomationSettings = (data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  const url = `${apiEndPoints.updateAutomationSettings}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const resetInvitation = (data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestThird(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.resendInvitation}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};

export const getS3Image = async (data) => {
  let url = data.split('/');
  url.pop();
  url.push('small.jpg');
  SetS3Config(IMGUPLOAD_S3, FILEUPLOAD_S3_LEVEL);
  try {
    const newData = await Storage.get(`${url.join('/')}`);
    return newData;
  } catch (err) {}
};

export const getPresignedURLForProfileImg = (file_path = '', file_size = '', excludeFromLoading = false, isLogin = true) => {
  const [tenantId, tenantSk] = getTenantDetails();
  const extraHeaders = { 'x-api-key': AppConfig.presignedUrlHeaderKey };
  let url = `${apiEndPoints.getPresignedURL}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&file_path=${file_path}&file_size=${file_size}&is_profile_image=true`;
  return performRequestSecond(apiEndPoints.methodType.GET, url, null, null, isLogin, excludeFromLoading, extraHeaders);
};

export const getPresignedURLOpen = (tenantId, tenantSk, file_path = '', file_size = '', excludeFromLoading = false) => {
  const _tenantSk = tenantSk ? tenantSk.replace('#', '%23') : '';
  const extraHeaders = { 'x-api-key': AppConfig.presignedUrlHeaderKey };
  let url = `${apiEndPoints.getPresignedURL}?tenant_id=${tenantId}&tenant_sk=${_tenantSk}&file_path=${encodeURIComponent(
    file_path
  )}&file_size=${file_size}&is_profile_image=false`;
  return performRequestSecond(apiEndPoints.methodType.GET, url, null, null, false, excludeFromLoading, extraHeaders);
};

export const getPresignedURLForUserProfileImg = (tenantId, tenant_sk, file_path, file_size) => {
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  const extraHeaders = { 'x-api-key': AppConfig.presignedUrlHeaderKey };
  let url = `${apiEndPoints.getPresignedURL}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&file_path=${file_path}&file_size=${file_size}&is_profile_image=true`;
  return performRequestSecond(apiEndPoints.methodType.GET, url, null, null, true, false, extraHeaders);
};

export const listRelationRoles = (
  pageLimit,
  pagination_token = '',
  pagination_direction = '',
  sort_order = 'alphabet_ascending',
  practice_area = '',
  is_dropdown = false
) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestThird(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.listRelationRoles}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&limit=${pageLimit}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}&practice_area_id=${practice_area}&sort_order=${sort_order}&is_dropdown=${is_dropdown}`
  );
};

export const createRelationRoles = (data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestThird(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.createRelationRoles}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};
export const updateRelationRoles = (data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestThird(
    apiEndPoints.methodType.PATCH,
    `${apiEndPoints.updateRelationRoles}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};
export const deleteRelationRoles = (pk, sk) => {
  let tenantId = cookie.get('tenantId');
  let tenantSk = cookie.get('tenantSk');
  tenantSk = tenantSk ? tenantSk.replace('#', '%23') : '';
  pk = pk ? pk.replace('#', '%23') : '';
  sk = sk ? sk.replaceAll('#', '%23') : '';
  let url = `${apiEndPoints.deleteRelationRoles}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&pk=${pk}&sk=${sk}`;
  return performRequestThird(apiEndPoints.methodType.DELETE, url);
};

export const listLeadSource = (
  pageLimit = 10,
  pagination_token = '',
  pagination_direction = 'forward',
  excludeFromLoading = false,
  inputValue = ''
) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestThird(
    apiEndPoints.methodType.GET,
    `${
      apiEndPoints.listLeadSource
    }?tenant_id=${tenantId}&tenant_sk=${tenantSk}&limit=${pageLimit}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}${
      inputValue ? `&keyword=${inputValue}` : ''
    }`,
    null,
    '',
    true,
    excludeFromLoading
  );
};

export const createLeadSource = (data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestThird(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.createLeadSource}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};
export const updateLeadSource = (data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestThird(
    apiEndPoints.methodType.PATCH,
    `${apiEndPoints.updateLeadSource}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};
export const deleteLeadSource = (pk, sk) => {
  let tenantId = cookie.get('tenantId');
  let tenantSk = cookie.get('tenantSk');
  tenantSk = tenantSk ? tenantSk.replace('#', '%23') : '';
  pk = pk ? pk.replace('#', '%23') : '';
  sk = sk ? sk.replaceAll('#', '%23') : '';
  let url = `${apiEndPoints.deleteLeadSource}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&pk=${pk}&sk=${sk}`;
  return performRequestThird(apiEndPoints.methodType.DELETE, url);
};

//settings module  -> job title `
export const createJobTitle = (data) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  return performRequestThird(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.createJobTitle}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};

export const getJobTitle = (
  pageLimit = 10,
  pagination_token = '',
  pagination_direction = 'forward',
  next = '',
  sort_order = 'alphabet_ascending',
  practice_area = ''
) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';

  return performRequestThird(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.getJobTitle}?tenant_id=${tenantId}&tenant_sk=${tenantSk}${next ? `&next=${next}` : ''}${
      pageLimit ? `&limit=${pageLimit}` : ''
    }&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}&practice_area_id=${practice_area}&sort_order=${sort_order} `
  );
};

export const deleteJobTitle = (sk) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';

  return performRequestThird(
    apiEndPoints.methodType.DELETE,
    `${apiEndPoints.deleteJobTitle}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&job_title_sk=${sk}`
  );
};

export const updateJobTitle = (data, sk) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  return performRequestThird(
    apiEndPoints.methodType.PATCH,
    `${apiEndPoints.updateJobTitle}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&job_title_sk=${sk}`,
    data
  );
};

//settings module -> global tags

export const createGlobalTags = (data) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  return performRequestThird(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.createGlobalTags}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};

export const listGlobalTags = (
  pageLimit,
  pagination_token = '',
  pagination_direction = 'forward',
  sort_order = 'alphabet_ascending',
  practiceAreaId = []
) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  let url = `${apiEndPoints.listGlobalTags}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&limit=${pageLimit}&pagination_direction=${pagination_direction}&sort_order=${sort_order}`;
  if (pagination_token) {
    url += `&pagination_token=${pagination_token}`;
  }
  if (practiceAreaId && practiceAreaId.length > 0) {
    url += `&practice_area_id=${practiceAreaId}`;
  }
  return performRequestThird(apiEndPoints.methodType.GET, url);
};

export const deleteGlobalTags = (pk, sk) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';

  return performRequestThird(
    apiEndPoints.methodType.DELETE,
    `${apiEndPoints.deleteGlobalTags}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&pk=${pk}&sk=${sk}`
  );
};

export const updateGlobalTags = (data, sk) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  return performRequestThird(
    apiEndPoints.methodType.PATCH,
    `${apiEndPoints.updateGlobalTags}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&global_tag_sk=${sk}`,

    data
  );
};

//settings-->Business Role

export const createBusinessRole = (data) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  return performRequestThird(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.createBusinessRole}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};

export const listBusinessRole = (
  pageLimit,
  pagination_token = '',
  pagination_direction = 'forward',
  excludeFromLoading = false,
  sort_order = 'alphabet_ascending',
  practice_area = ''
) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';

  return performRequestThird(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.listBusinessRole}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&limit=${pageLimit}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}&practice_area_id=${practice_area}&sort_order=${sort_order}`,
    null,
    '',
    true,
    excludeFromLoading
  );
};

export const deleteBusinessRole = (pk, sk) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';

  return performRequestThird(
    apiEndPoints.methodType.DELETE,
    `${apiEndPoints.deleteBusinessRole}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&pk=${pk}&sk=${sk}`
  );
};

export const updateBusinessRole = (data, sk) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  return performRequestThird(
    apiEndPoints.methodType.PATCH,
    `${apiEndPoints.updateBusinessRole}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&business_role_sk=${sk}`,
    data
  );
};

export const updateOutcome = (outcome_reason_pk, outcome_reason_sk, data) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  return performRequestThird(
    apiEndPoints.methodType.PATCH,
    `${apiEndPoints.updateOutcome}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&outcome_reason_pk=${outcome_reason_pk}&outcome_reason_sk=${outcome_reason_sk}`,
    data
  );
};

export const deleteOutcome = (outcome_reason_pk, outcome_reason_sk) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  return performRequestThird(
    apiEndPoints.methodType.DELETE,
    `${apiEndPoints.deleteOutcome}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&pk=${outcome_reason_pk}&sk=${outcome_reason_sk}`
  );
};

export const deleteClosureReason = (pk, sk) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  return performRequestThird(
    apiEndPoints.methodType.DELETE,
    `${apiEndPoints.deleteClosureReason}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&pk=${pk}&sk=${sk}`
  );
};

export const updateReason = (closure_reason_pk, closure_reason_sk, data) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  return performRequestThird(
    apiEndPoints.methodType.PATCH,
    `${apiEndPoints.updateClosureReason}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&closure_reason_pk=${closure_reason_pk}&closure_reason_sk=${closure_reason_sk}`,
    data
  );
};

/** =============================================================  Workflow Automation Related API services starts ==================================================== **/

export const getAutomationRules = (
  next,
  practice_area,
  case_matter,
  automation_status,
  pageLimit,
  pagination_token,
  pagination_direction
) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestSecond(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.listAutomationRules}?tenant_id=${tenantId}&tenant_sk=${tenantSk}${next ? `&next=${next}` : ''}${
      pageLimit ? `&limit=${pageLimit}` : ''
    }${practice_area ? `&practice_area=${practice_area}` : ''}${case_matter ? `&case_matter=${case_matter}` : ''}${
      automation_status ? `&automation_status=${automation_status.replace(/%20/g, ' ').trim()}` : ''
    }&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}`
  );
};

export const createAutomationRule = (data, additionalParams = '') => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestSecond(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.createAutomationRules}?tenant_id=${tenantId}&tenant_sk=${tenantSk}${additionalParams ? `&${additionalParams}` : ''}`,
    data
  );
};

export const manualAutomationTrigger = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  const payloadData = {
    ...data,
    tenant_id: tenantId,
  };
  return performRequestSecond(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.manualAutomationTrigger}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    payloadData
  );
};

//Automation Error-Log Related API Services
export const listAutomationErrorLogs = (sk = '', data = {}, page_limit = 10, pagination_token = '', pagination_direction = 'forward') => {
  const [tenantId, tenantSk] = getTenantDetails();

  return performRequestThird(
    apiEndPoints.methodType.POST,
    `${apiEndPoints?.listAutomationErrorLogs}?tenant_id=${tenantId ? tenantId : ''}&tenant_sk=${tenantSk ? tenantSk : ''}&sk=${
      sk ? sk : ''
    }&limit=${page_limit ? page_limit : ''}&pagination_token=${pagination_token ? pagination_token : ''}&pagination_direction=${
      pagination_direction ? pagination_direction : ''
    }`,
    data
  );
};

/** =============================================================  Workflow Automation Related API services ends ==================================================== **/
// venue crud operation
export const getVenueList = (
  page_limit = 10,
  pagination_token = '',
  pagination_direction = 'forward',
  excludeFromLoading = false,
  sort_order = 'alphabet_ascending',
  practiceAreaId = [],
  inputValue = ''
) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  return performRequestThird(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.getVenue}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&limit=${page_limit ? page_limit : 10}&pagination_token=${
      pagination_token ? pagination_token : ''
    }&pagination_direction=${pagination_direction ? pagination_direction : ''}&practice_area_id=${
      practiceAreaId ? practiceAreaId : ''
    }&sort_order=${sort_order}${inputValue ? `&keyword=${inputValue}` : ''}`,
    null,
    '',
    true,
    excludeFromLoading
  );
};

export const createVenue = (data) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  //as an object {}
  return performRequestThird(apiEndPoints.methodType.POST, `${apiEndPoints.createVenue}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`, data);
};

export const updateVenue = (data = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestThird(apiEndPoints.methodType.PUT, `${apiEndPoints.updateVenue}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`, data);
};

//ReviewRequestUrls Cred Operations

export const listSettingsReviewRequestUrls = (
  config_type = '',
  pageLimit,
  pagination_token = '',
  pagination_direction = '',
  is_dropdown = false
) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestThird(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.listReviewRequestUrls}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&config_type=${config_type}&limit=${pageLimit}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}&is_dropdown=${is_dropdown}`
  );
};

export const createReviewRequestUrl = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestThird(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.createReviewRequestUrl}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};

export const updateReviewRequestUrl = (config_type = '', data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestThird(
    apiEndPoints.methodType.PUT,
    `${apiEndPoints.updateReviewRequestUrl}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&config_type=${config_type}`,
    data
  );
};

export const deleteReviewRequestUrl = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestThird(
    apiEndPoints.methodType.DELETE,
    `${apiEndPoints.deleteReviewRequestUrl}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};

export const listRequestReviewMessage = (config_type = '') => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestThird(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.listReviewRequestUrls}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&config_type=${config_type}`
  );
};

export const sendReviewRequest = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestThird(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.sentReviewRequest}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};

//Experts

export const createExpert = (data) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  return performRequestThird(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.createExpert}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`,
    data
  );
};

export const listExperts = (
  pageLimit,
  pagination_token = '',
  pagination_direction = 'forward',
  excludeFromLoading = false,
  sort_order = 'alphabet_ascending',
  practice_area = ''
) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';

  return performRequestThird(
    apiEndPoints.methodType.GET,
    `${apiEndPoints?.listExperts}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&limit=${pageLimit}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}&sort_order=${sort_order}&practice_area_id=${practice_area}`,
    null,
    '',
    true,
    excludeFromLoading
  );
};

export const updateExpert = (data, sk) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  return performRequestThird(
    apiEndPoints.methodType.PATCH,
    `${apiEndPoints.updateExpert}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&expert_sk=${sk}`,
    data
  );
};

export const deleteExpert = (pk, sk) => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';

  return performRequestThird(
    apiEndPoints.methodType.DELETE,
    `${apiEndPoints.deleteExpert}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&pk=${pk}&sk=${sk}`
  );
};

// Conference Room APIs
export const listConferenceRooms = (officeLocationId = '') => {
  const [tenantId, tenantSk] = getTenantDetails();

  if (!tenantId || !tenantSk) {
    console.error('Missing tenant details for listConferenceRooms:', { tenantId, tenantSk });
    return Promise.reject(new Error('Tenant details are required'));
  }

  const params = new URLSearchParams({
    tenant_id: tenantId,
    tenant_sk: tenantSk,
  });

  if (officeLocationId) {
    params.append('office_location_id', officeLocationId);
  }

  return performRequestThird(apiEndPoints.methodType.GET, `${apiEndPoints.listConferenceRooms}?${params.toString()}`);
};

export const createConferenceRoom = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  const { office_location_id, ...roomData } = data;

  return performRequestThird(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.createConferenceRoom}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&office_location_id=${office_location_id}`,
    roomData
  );
};

export const updateConferenceRoom = (conferenceRoomId, data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  const { office_location_id, ...roomData } = data;

  return performRequestThird(
    apiEndPoints.methodType.PUT,
    `${apiEndPoints.updateConferenceRoom}/${conferenceRoomId}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&conference_room_id=${conferenceRoomId}`,
    roomData
  );
};

export const deleteConferenceRoom = (conferenceRoomId) => {
  const [tenantId, tenantSk] = getTenantDetails();
  return performRequestThird(
    apiEndPoints.methodType.DELETE,
    `${apiEndPoints.deleteConferenceRoom}/${conferenceRoomId}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&conference_room_id=${conferenceRoomId}`
  );
};

export const getConferenceRoomAvailability = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();

  if (!tenantId || !tenantSk) {
    console.error('Missing tenant details for getConferenceRoomAvailability:', { tenantId, tenantSk });
    return Promise.reject(new Error('Tenant details are required'));
  }

  if (!data.office_location_id) {
    console.error('Missing office_location_id for getConferenceRoomAvailability:', data);
    return Promise.reject(new Error('Office location ID is required'));
  }

  return performRequestSecond(
    apiEndPoints.methodType.POST,
    `${apiEndPoints.getConferenceRoomAvailability}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&office_location_id=${data.office_location_id}`,
    data
  );
};
